import Exception from './Exception';
/**
 * Custom Error class of type Exception.
 */
export default class UnsupportedOperationException extends Exception {
}
UnsupportedOperationException.kind = 'UnsupportedOperationException';
//# sourceMappingURL=UnsupportedOperationException.js.map